import React from "react";
import WorksImgone from "../works/WorksImgOne";
import WorksImgTwo from "../works/WorksImgTwo";
import BlueWork from "../works/BlueWork";
import WhiteWork from "../works/WhiteWork";
import Img from "../resources/techLanka.jpg";
import Img2 from "../resources/lipapap.jpg";
import Img3 from "../resources/kavinduMotors.png";
import Img4 from "../resources/edubook.jpg";
import Img5 from "../resources/taprodev.png";

export default function WebProjects() {
  return (
    <div className="col-10 offset-1 text-white" id="WEB">
      <div className="row">
        <div className=" col-12 col-lg-9  text-start aboutText mt-5 mb-5">
          <h6 className="text-uppercase fs-1 fw-bold text-info ">Web Projects</h6>
          <p className="homePara text-base text-sm lg:text-base">
            Our web projects include but are not limited to responsive websites,
            e-commerce platforms, content management systems, and mobile
            applications. We ensure that our projects are not only visually
            appealing but also user-friendly and optimized for search engines.
            Check out some of our featured projects below.
          </p>
        </div>

        <WorksImgone img={Img} />
        <BlueWork
          title="WEB STORE - E-COMMERCE WEB"
          name="TECH LANKA"
          discription="Tech Lanka is a free e-commerce platform that specializes in electronic items buying and selling. It offers a wide range of electronic products, including mobile phones, laptops, cameras, gaming consoles, audio systems, and many more. "
          link="/techlanka"
        />

        <WhiteWork
          title="WEB - PAYMENT GATEWAY "
          name="LIPAPAP"
          discription="LipaPap is a dynamic and innovative Payment Solutions Provider committed to delivering cutting-edge payment solutions to clients worldwide. "
          link="/lipapap"
        />
        <WorksImgTwo img={Img2} />

        <WorksImgone img={Img3} />
        <BlueWork
          title="WEB STORE "
          name="Kavindu Motors"
          discription="This is a web site for car modification item selling store. Customers can send thiere orders to store using this application  "
          link="/kavindumotors"
        />

        <WhiteWork
          title="LEARNING MANAGEMENT SYSTEM "
          name="EDUBOOK"
          discription="This learning management systems work to coordinate scheduling and communications between faculty regarding students. "
          link="/edubook"
        />
        <WorksImgTwo img={Img4} />

        <WorksImgone img={Img5} />
        <BlueWork
          title="WEB PORTFOLIO "
          name="TaproDev"
          discription="This is our official web site.Taprodev is a website that has been developed using ReactJS, a popular front-end JavaScript library for building user interfaces. ReactJS allows for the creation of reusable UI components that can be easily integrated into a single-page application."
          link="/taprodev"
        />
      </div>
    </div>
  );
}
